import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { EmailLibraryModule } from './../../email-library.module';
import { Template } from '../card/card.component';
import { OwnerType } from '@vendasta/email-builder';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

export interface PageComponentDialogData {
  openAsReadOnly: boolean;
  ownerId: string;
  userId: string;
  ownerType: OwnerType;
  showPageActions: boolean;
}

@Component({
  imports: [
    CommonModule, //
    RouterModule,
    TranslateModule,
    MatButtonModule,
    GalaxyPageModule,
    EmailLibraryModule,
  ],
  selector: 'email-page',
  templateUrl: './page.component.html',
})
export class PageComponent {
  @Input() openAsReadOnly = false;
  @Input() ownerType: OwnerType = OwnerType.OWNER_TYPE_ACCOUNT_GROUP;
  @Input() ownerId: string;
  @Input() userId: string;
  @Input() showPageActions = false;

  constructor(
    private readonly dialogRef: MatDialogRef<PageComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: PageComponentDialogData,
    private posthogService: ProductAnalyticsService,
  ) {
    if (dialogData) {
      this.openAsReadOnly = !!dialogData.openAsReadOnly;
      if (dialogData.ownerType) {
        this.ownerType = dialogData.ownerType;
      }
      this.ownerId = dialogData.ownerId;
      this.userId = dialogData.userId;
      this.showPageActions = dialogData.showPageActions;
    }
  }

  handleReadOnlyEmailClicked(template: Template): void {
    this.dialogRef.close(template);
  }

  registerPosthog() {
    this.posthogService.trackEvent('user-clicked-create-email', 'email-library', 'click', null);
  }
}
